export default __webpack_public_path__ + "static/media/ic_arrow_left.f35e8058.svg";